import { Injectable, Pipe, PipeTransform } from '@angular/core';

@Injectable({ providedIn: 'root' })
@Pipe({
    name: 'join',
})
export class JoinPipe implements PipeTransform {
    transform(values: string[], separator = ', '): string {
        return values?.join(separator) ?? '';
    }
}
